import { MutationTree } from "vuex";
import { IUserState } from "@/store/modules/user/state";
import { User } from "@/types";
import { IDataProvider } from "@/store";

export enum UserMutations {
  SET_ONE = "SET_ONE_USER",
  SET_PROFILE = "SET_PROFILE_USER",
  SET_ALL = "SET_ALL_USER",
  SET_LAZY_DATA = "SET_LAZY_DATA_CATEGORY",
}

export const mutations: MutationTree<IUserState> = {
  [UserMutations.SET_ONE](state, payload: User) {
    state.user = payload;
  },
  [UserMutations.SET_PROFILE](state, payload: User) {
    state.profile = payload;
  },
  [UserMutations.SET_ALL](state, payload: User[]) {
    state.users = payload;
  },
  [UserMutations.SET_LAZY_DATA](state, payload: IDataProvider<User>) {
    state.dataProvider = payload;
  },
};
